import step1Img from '../assets/new-design/step1.png';
import step2Img from '../assets/new-design/step2.png';
import step3Img from '../assets/new-design/step3.png';
import step4Img from '../assets/new-design/step4.png';
import partnerBenefit1 from '../assets/new-design/partner-benefit1.png';
import partnerBenefit2 from '../assets/new-design/partner-benefit2.png';
import partnerBenefit3 from '../assets/new-design/partner-benefit3.png';

import {
  ComparisonRow,
  FAQ,
  HowItWorksStep,
  PartnerBenefit,
  Persona,
  Plan,
  Stat,
} from '../types/HomeTypes';

export const STATS: Stat[] = [
  { value: '+500', label: 'lava-rápidos parceiros credenciados' },
  { value: '+120 mil', label: 'lavagens realizadas na rede' },
  { value: '4', label: 'capitais: SP, RJ, BH e Brasília' },
  { value: '<2 min', label: 'pra assinar pelo site' },
];

export const COMPARISON_ROWS: ComparisonRow[] = [
  { criteria: 'Custo no mês', avulso: 'R$ 300+ se lava toda semana', washpass: 'Fixo a partir de R$ 99,90, ilimitado' },
  { criteria: 'Choveu depois?', avulso: 'Perdeu o dinheiro da lavagem', washpass: 'Lave de novo, sem custo extra' },
  { criteria: 'Onde lava', avulso: 'Preso a um lava-rápido perto', washpass: '+500 parceiros em várias cidades' },
  { criteria: 'Qualidade', avulso: 'Muda a cada lugar, imprevisível', washpass: 'Rede credenciada, padrão garantido' },
  { criteria: 'Como paga', avulso: 'Preço diferente toda vez, fila', washpass: 'Escaneie o QR Code, sem fila' },
];

export const AVULSO_ITEMS: string[] = [
  'Você decide onde, quando e por quanto lavar, de novo e de novo',
  'Preço que muda a cada lugar, fila e espera',
  'Qualidade incerta: às vezes vem mal feita',
  'No fim do mês, a conta some: tudo saiu solto',
];

export const WASHPASS_ITEMS: string[] = [
  'Assinou uma vez, lava quando quiser, quantas vezes quiser',
  'Valor fixo no mês, previsível: você sabe exatamente quanto gasta',
  'Rede credenciada com padrão de qualidade, +500 parceiros',
  'Escaneie o QR Code e lava, sem fila e sem pagar na hora',
];

export const PLANS_PESSOAL: Plan[] = [
  {
    id: 'washflex',
    name: 'WASHFLEX',
    subtitle: 'LAVAGEM SIMPLES ILIMITADA',
    price: '104',
    cents: '90',
    annualPrice: '69',
    annualCents: '90',
    monthlyLabel: 'Cancele quando quiser',
    economize: 'Economize R$ 420/ano',
    installment: 'ou 12x de R$ 122,73',
    pricingG: {
      price: '120', cents: '90',
      annualPrice: '80', annualCents: '90',
      economize: 'Economize R$ 480/ano',
      installment: 'ou 12x de R$ 141,45',
    },
    notIncluded: 'Não inclui aplicação de cera',
    features: [
      'Lavagem simples ilimitada em toda a rede',
      '+500 parceiros credenciados (plano cobre 20% da rede)',
      'Suporte ao assinante',
    ],
    badge: 'none',
    cta: 'Assinar WashFlex',
    highlight: false,
  },
  {
    id: 'washelite',
    name: 'WASHELITE',
    subtitle: 'LAVAGEM COMPLETA ILIMITADA',
    price: '146',
    cents: '90',
    annualPrice: '97',
    annualCents: '90',
    monthlyLabel: 'Melhor custo-benefício',
    economize: 'Economize R$ 588/ano',
    installment: 'ou 12x de R$ 171,87',
    pricingG: {
      price: '169', cents: '90',
      annualPrice: '112', annualCents: '90',
      economize: 'Economize R$ 684/ano',
      installment: 'ou 12x de R$ 198,78',
    },
    notIncluded: 'Não inclui aplicação de cera',
    features: [
      'Lavagem completa na Rede Elite',
      '+500 parceiros credenciados (plano cobre 90% da rede)',
      'Higienização interna completa',
      'Suporte ao assinante prioritário',
    ],
    badge: 'popular',
    cta: 'Assinar WashElite',
    highlight: true,
  },
  {
    id: 'washultra',
    name: 'WASHULTRA',
    subtitle: 'LAVAGEM DETALHADA ILIMITADA',
    price: '195',
    cents: '90',
    annualPrice: '132',
    annualCents: '90',
    monthlyLabel: 'Experiência completa',
    economize: 'Economize R$ 756/ano',
    installment: 'ou 12x de R$ 229,20',
    pricingG: {
      price: '225', cents: '90',
      annualPrice: '152', annualCents: '90',
      economize: 'Economize R$ 876/ano',
      installment: 'ou 12x de R$ 264,30',
    },
    notIncluded: '',
    features: [
      'Lavagem de estética automotiva',
      '+500 parceiros credenciados (plano cobre 100% da rede)',
      'Concierge para agendamento via WhatsApp',
      'Suporte ao assinante exclusivo prioritário',
    ],
    badge: 'premium',
    cta: 'Assinar WashUltra',
    highlight: false,
  },
];

export const PLANS_TRABALHO: Plan[] = [
  {
    id: 'probasic',
    name: 'PRO BASIC',
    subtitle: 'LAVAGEM PROFISSIONAL LIMITADA',
    price: '179',
    cents: '90',
    annualPrice: '149',
    annualCents: '90',
    economize: 'Economize R$ 360/ano',
    installment: 'ou 12x de R$ 210,48',
    notIncluded: '',
    features: [
      'Até 6 lavagens por mês (fora + aspiração)',
      'Não cumulativo — o saldo reinicia todo mês',
      'Prioridade máxima no atendimento',
      '500+ parceiros — SP, RJ, BH, BSB',
      'Nota fiscal mensal',
      'Suporte 24/7',
    ],
    badge: 'none',
    cta: 'Assinar Pro Basic',
    highlight: false,
  },
  {
    id: 'proplus',
    name: 'PRO PLUS',
    subtitle: 'LAVAGEM PROFISSIONAL COMPLETA',
    price: '268',
    cents: '90',
    annualPrice: '219',
    annualCents: '90',
    economize: 'Economize R$ 588/ano',
    installment: 'ou 12x de R$ 314,61',
    notIncluded: '',
    features: [
      'Até 10 lavagens por mês (fora + aspiração)',
      'Não cumulativo — o saldo reinicia todo mês',
      'Higienização interna completa',
      'Aromatização a cada lavagem',
      'Relatório mensal de uso',
      'Gerente de conta dedicado',
    ],
    badge: 'completo',
    cta: 'Assinar Pro Plus',
    highlight: true,
  },
];

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  { n: 1, title: 'Assine pelo site', desc: 'Escolha o plano e assine em menos de 2 minutos. Sem burocracia.', img: step1Img },
  { n: 2, title: 'Ache o parceiro no app', desc: 'Digite seu CEP e veja o parceiro credenciado mais perto de você na rede.', img: step2Img },
  { n: 3, title: 'Escaneie o QR Code', desc: 'Chegou no parceiro? É só ler o QR Code da sua assinatura e lavar.', img: step3Img },
  { n: 4, title: 'Carro limpo', desc: 'Sem fila, sem dor de cabeça. Repita quando precisar, dentro da rede do seu plano.', img: step4Img },
];

export const PERSONAS: Persona[] = [
  {
    title: 'Profissional ocupado',
    quote: '"Seu tempo vale mais que uma fila de lava-rápido."',
    desc: 'Agenda lotada, zero tempo pra se preocupar com a manutenção do carro. Quer comodidade e qualidade sem perder a manhã de sábado numa fila.',
    icon: 'user',
  },
  {
    title: 'Motorista de app',
    quote: '"Seu carro é seu cartão de visitas, e sua ferramenta de trabalho."',
    desc: 'O passageiro entra, vê o carro e decide sua nota em 5 segundos. Carro impecável é nota protegida, e nota protegida é renda protegida.',
    icon: 'send',
    extraLink: 'É motorista de app? Clique aqui',
  },
  {
    title: 'Pai / mãe de família',
    quote: '"Criança, pet, rotina, e o carro limpo mesmo assim."',
    desc: 'O carro vive sujo com a correria do dia a dia e não sobra tempo pra fila. Quer segurança, qualidade confiável e preço justo, sem complicação.',
    icon: 'family',
  },
  {
    title: 'Entusiasta de carros',
    quote: '"Pra quem trata o carro como merece."',
    desc: 'Ama o carro e exige cuidado constante. O lava-rápido comum não tem o padrão que você quer. Busca parceiros especializados.',
    icon: 'car',
  },
];

export const FAQS: FAQ[] = [
  { q: 'Preciso baixar algum app para assinar?', a: 'Não. Você assina direto pelo site em menos de 2 minutos. O app existe só para facilitar o uso depois.' },
  { q: 'Como funciona na prática?', a: 'Assine pelo site, baixe o app, digite seu CEP e escaneie o QR Code da sua assinatura no parceiro mais perto.' },
  { q: 'Tem parceiro perto de mim?', a: 'Operamos em São Paulo, Rio de Janeiro, Belo Horizonte e Brasília, com mais de 500 parceiros credenciados.' },
  { q: 'As lavagens são realmente ilimitadas?', a: 'Sim, dentro da rede do seu plano, por um valor fixo no mês.' },
  { q: 'Posso cancelar quando quiser?', a: 'Sim, sem multa e sem fidelidade.' },
];

export const PARTNER_BENEFITS: PartnerBenefit[] = [
  {
    title: 'Atenda nossa frota',
    desc: 'Ofereça seus serviços para um fluxo constante de clientes, aumentando a visibilidade e rentabilidade do seu negócio.',
    cta: 'Rentabilize seu negócio',
    imgSrc: partnerBenefit2,
  },
  {
    title: 'Pagamento garantido',
    desc: 'Receba os pagamentos de forma segura. Seus ganhos serão transferidos para sua conta 30 dias após o fechamento do mês e emissão da sua nota fiscal.',
    cta: 'Fature mais',
    imgSrc: partnerBenefit1,
  },
  {
    title: 'Menos tempo ocioso',
    desc: 'Mantenha seu lava-rápido sempre movimentado, garantindo um fluxo constante de clientes e evitando períodos ociosos.',
    cta: 'Junte-se à rede WashPass',
    imgSrc: partnerBenefit3,
  },
];
